import React from 'react';
import Modal from 'react-modal';

import { useTheme } from '../../../hooks/useTheme';

import { ReactComponent as Close } from '../../../icons/close.svg';

import './dialog.scss';

import { Button } from '../button/Button';

Modal.setAppElement('#root');

const Dialog = ({
  isOpen,
  icon: Icon,
  title,
  message,
  primaryText,
  secondaryText,
  onPrimaryClick,
  onSecondaryClick,
  onClose
}) => {
  const { getThemeVariable } = useTheme();

  const modalStyles = {
    content: {
      color: getThemeVariable('text-primary'),
      background: getThemeVariable('background-modal'),
      border: `1px solid ${getThemeVariable('background-modal')}`
    }
  };

  return (
    <>
      {isOpen && (
        <Modal
          isOpen={isOpen}
          style={modalStyles}
          overlayClassName="dialog__overlay"
          className="dialog__content"
        >
          <div style={{ background: getThemeVariable('background-modal') }} className="dialog">
            <div>
              <Close
                width={24}
                height={24}
                style={{ color: getThemeVariable('text-primary') }}
                onClick={onClose}
              />
            </div>
            {Icon && Icon}
            {title && <h1 style={{ color: getThemeVariable('text-primary') }}>{title}</h1>}
            {message &&
              (typeof message === 'string' && message.includes('<') ? (
                <span dangerouslySetInnerHTML={{ __html: message }} />
              ) : (
                <span>{message}</span>
              ))}
            <div>
              {primaryText && <Button onClick={onPrimaryClick}>{primaryText}</Button>}
              {secondaryText && (
                <Button onClick={onSecondaryClick} secondary>
                  {secondaryText}
                </Button>
              )}
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default Dialog;
